import styled from 'styled-components'

import colors from '@settings/styleSettings'

export const Container = styled.div`
  border-radius: 12px 12px 0px 0px;
  background-color: ${(props) => (!props.state ? colors.titleStrongWhite : colors.primary)};
  width: 100%;
`

export const Row = styled.div`
  display: flex;
  width: 100%;
  height: 72px;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
`

export const SearchContainer = styled.div`
  display: flex;
  flex: 1;
  margin: 0px 30px;
  align-items: center;
  justify-content: center;
`

export const FeatureContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  margin-right: 30px;
`

export const SearchIcon = styled.div`
  cursor: pointer;
  color: ${(props) => (props.state ? colors.titleStrongWhite : colors.strongGray)};
  position: absolute;
  right: 16px;
`

export const TuneIcon = styled.div`
  cursor: pointer;
  color: ${(props) => (!props.state ? colors.strongGray : colors.titleStrongWhite)};
  margin-top: 5px;
`

export const Button = styled.div`
  background: transparent;
`

export const Input = styled.input`
  width: 100%;
  flex: 1;
  min-height: 48px;
  border-radius: 12px;
  border: 1px solid ${colors.softGray};
  &:focus {
    border-color: ${colors.primary};
    outline: none;
  }
  ::placeholder {
    color: ${colors.strongGray};
  }
  font-family: inherit;
  color: ${colors.titleStrongBlack};
  font-size: 16px;
  box-sizing: border-box;
  padding-left: 16px;
  vertical-align: baseline;
  max-width: 100%;
`
export const InputContainer = styled.div`
  width: 100%;
  position: relative;
  display: flex;
  flex: 1;
  align-items: center;
`
